// transactionStatusesMapper.js

export const transactionStatusesMapType = {
  NOT_PAID: 'NOT_PAID',
  PAID: 'PAID',
  // DENIED: 'DENIED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  EXPIRED_FAILED: 'EXPIRED_FAILED'
}

const transactionStatusesMapping = (intl) => ({
  [transactionStatusesMapType.NOT_PAID]: {
    label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.notPaid' }),
    color: 'warning'
  },
  [transactionStatusesMapType.PAID]: {
    label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.paid' }),
    color: 'success'
  },
  // [transactionStatusesMapType.DENIED]: {
  //   label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.denied' }),
  //   color: 'fail'
  // },
  [transactionStatusesMapType.EXPIRED]: {
    label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.expired' }),
    color: 'fail'
  },
  [transactionStatusesMapType.FAILED]: {
    label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.failed' }),
    color: 'fail'
  },
  [transactionStatusesMapType.EXPIRED_FAILED]: {
    label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.expiredFailed' }),
    color: 'fail'
  }
  // PENDING: {
  //   label: intl.formatMessage({ id: 't.app.paybylink.transactionStatus.pending' }),
  //   color: 'warning'
  // }
})

export const mapTransactionStatusesToLabelAndColor = (userStatus, intl) => {
  const statuses = transactionStatusesMapping(intl)
  return statuses[userStatus] || { label: '', color: '' }
}
